import { HttpStatuses } from '@shared/constants';

export class InterceptorException extends Error {
  public status: HttpStatuses;
  public isErrorSolved: boolean;
  public originalException?: unknown | string | Error;

  constructor(isErrorSolved: boolean, msg: string, originalException?: unknown | string | Error) {
    super(msg);
    this.status = HttpStatuses.ImTeapot;
    this.isErrorSolved = isErrorSolved;
    this.originalException = originalException;
  }
}
